var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewMenuDelis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 29,
    viewBox: "0 0 33 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7051 2.50781L1.70508 14.7801V20.2355H31.7051V14.7801L16.7051 2.50781Z",
    stroke: "#240b3b",
    strokeWidth: 2.3875,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8345 25.6961H1.70508V20.2363H31.7051V25.6961H18.589",
    stroke: "#240b3b",
    strokeWidth: 2.3875,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.70508 14.7793H31.7051",
    stroke: "#240b3b",
    strokeWidth: 2.3875,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33398 20.2363L14.834 25.6961L16.7045 27.0533L18.5884 25.6961L26.0884 20.2363",
    stroke: "#240b3b",
    strokeWidth: 2.3875,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMenuDelis);
export default __webpack_public_path__ + "static/media/new-menu-delis.ecb68c67ca86d0a6b92e22291b9880d2.svg";
export { ForwardRef as ReactComponent };